import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Tooltip,
  Checkbox,
  Grid,
  Divider,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import axios from "axios.js";

function CourseTest() {
  const pageTitle = "Course Quiz";
  usePageTitle(pageTitle);
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);
  const [quizTitle, setQuizTitle] = useState(null);
  const [quizDescription, setQuizDescription] = useState(null);
  const [quizPassMark, setQuizPassMark] = useState(null);
  const [insights, setInsights] = useState(null);
  const [openEditQuizDialog, setOpenEditQuizDialog] = useState(false);

  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [quizQuestion, setQuizQuestion] = useState(null);
  const [openAddQuestionDialog, setOpenAddQuestionDialog] = useState(false);
  const [openEditQuestionDialog, setOpenEditQuestionDialog] = useState(false);
  const [answerText, setAnswerText] = useState(null);
  const [isAnswerCorrect, setIsAnswerCorrect] = useState(false);
  const [openAddAnswerDialog, setOpenAddAnswerDialog] = useState(false);

  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/trainings/quizzes/${ref}/fetch.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setInsights(result.data.data.quiz.insights);
            setQuizTitle(result.data.data.quiz.title);
            setQuizDescription(result.data.data.quiz.description);
            setQuizPassMark(result.data.data.quiz.pass_mark * 100);
            setQuestions(result.data.data.quiz.questions);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  const editQuiz = async () => {
    if (quizTitle === null) {
      setSeverity("error");
      setErrMsg("Name is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    if (quizDescription === null) {
      setSeverity("error");
      setErrMsg("Description is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    if (quizPassMark === null) {
      setSeverity("error");
      setErrMsg("Pass mark is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    setOpenEditQuizDialog(false);
    setShowLoading(true);

    const json = {
      reference: ref,
      title: `${quizTitle}`,
      description: `${quizDescription}`,
      pass_mark: parseFloat(quizPassMark, 10) / 100,
    };

    console.log(json);

    await axios
      .post("portal/trainings/quizzes/modify.json", json)
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  };

  const addQuestion = async () => {
    if (quizQuestion === null) {
      setSeverity("error");
      setErrMsg("Question is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    setOpenAddQuestionDialog(false);
    setShowLoading(true);

    const json = {
      reference: ref,
      question: `${quizQuestion}`,
    };

    await axios
      .post("portal/trainings/quizzes/questions/create.json", json)
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  };

  const editQuestion = async () => {
    if (quizQuestion === null) {
      setSeverity("error");
      setErrMsg("Question is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    setOpenEditQuestionDialog(false);
    setShowLoading(true);

    const json = {
      reference: selectedQuestion.reference,
      question: `${quizQuestion}`,
    };

    await axios
      .post("portal/trainings/quizzes/questions/modify.json", json)
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  };

  const addAnswer = async () => {
    if (answerText === null) {
      setSeverity("error");
      setErrMsg("Answer is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    if (isAnswerCorrect === null) {
      setSeverity("error");
      setErrMsg("Answer correctness is required");
      setOpen(true);
      setShowLoading(false);
      return;
    }

    setOpenAddAnswerDialog(false);
    setShowLoading(true);

    const json = {
      reference: selectedQuestion.reference,
      answer: `${answerText}`,
      correct: isAnswerCorrect,
    };

    await axios
      .post("/portal/trainings/quizzes/questions/answers/create.json", json)
      .then((response) => {
        if (response.data.status === "success") {
          setSeverity("success");
          setErrMsg(response.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(response.data.data.message);
          setOpen(true);
        }
        setShowLoading(false);
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  };

  async function deleteQuestion(questionRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/trainings/quizzes/questions/${questionRef}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteAnswer(answerRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/trainings/quizzes/questions/answers/${answerRef}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openEditQuizDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Edit Assessment</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                value={quizTitle}
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setQuizTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4}>
              <MDInput
                multiline
                rows={4}
                name="content"
                value={quizDescription}
                margin="dense"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setQuizDescription(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4}>
              <MDInput
                name="title"
                value={quizPassMark}
                margin="dense"
                label="Pass Mark %"
                type="decimal"
                fullWidth
                variant="outlined"
                onChange={(e) => setQuizPassMark(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditQuizDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              editQuiz();
            }}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddQuestionDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Question</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                value={quizQuestion}
                margin="dense"
                label="Question"
                type="text"
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                onChange={(e) => setQuizQuestion(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddQuestionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              addQuestion();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditQuestionDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Edit Question</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                value={quizQuestion}
                margin="dense"
                label="Question"
                type="text"
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                onChange={(e) => setQuizQuestion(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditQuestionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              editQuestion();
            }}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddAnswerDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Answer</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                value={answerText}
                margin="dense"
                label="Answer"
                type="text"
                fullWidth
                multiline
                minRows={3}
                variant="outlined"
                onChange={(e) => setAnswerText(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={isAnswerCorrect}
                onChange={(e) => {
                  setIsAnswerCorrect(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Correct Answer?
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddAnswerDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              addAnswer();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={1} mb={3}>
        <MDBox>
          <Button
            size="small"
            color="dark"
            startIcon={<Icon>west</Icon>}
            onClick={() => {
              window.history.go(-1);
            }}
          >
            Back To Course
          </Button>
        </MDBox>
        {insights !== null ? (
          <MDBox mt={3}>
            <MDBox>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4} lg={4}>
                  <Card>
                    <MDBox p={3} align="center">
                      <MDTypography variant="h6" fontWeight="medium" fontSize={24}>
                        {insights.participants}
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="light">
                        Agents
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <Card>
                    <MDBox p={3} align="center">
                      <MDTypography variant="h6" fontWeight="medium" fontSize={24}>
                        {insights.seatings}
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="light">
                        Seatings
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <Card>
                    <MDBox p={3} align="center">
                      <MDTypography variant="h6" fontWeight="medium" fontSize={24}>
                        {insights.participation.toFixed(2)}%
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="light">
                        Participation
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={3} lg={3}>
                  <Card>
                    <MDBox p={3} align="center">
                      <MDTypography variant="h6" fontWeight="medium" fontSize={24}>
                        {insights.passed}
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="light">
                        Passed
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <Card>
                    <MDBox p={3} align="center">
                      <MDTypography variant="h6" fontWeight="medium" fontSize={24}>
                        {insights.average_attempts}
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="light">
                        Average Attempts
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <Card>
                    <MDBox p={3} align="center">
                      <MDTypography variant="h6" fontWeight="medium" fontSize={24}>
                        {insights.pass_rate.toFixed(2)}%
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="light">
                        Pass Rate
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={3} lg={3}>
                  <Card>
                    <MDBox p={3} align="center">
                      <MDTypography variant="h6" fontWeight="medium" fontSize={24}>
                        {insights.conversion.toFixed(2)}%
                      </MDTypography>
                      <MDTypography variant="caption" fontWeight="light">
                        Overall Performance
                      </MDTypography>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
        ) : (
          <> </>
        )}
        <MDBox mt={3}>
          <Divider />
        </MDBox>
        <MDBox mt={3}>
          <Card sx={{ width: "100%", marginTop: "15px" }}>
            <MDBox p={3}>
              <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                    {quizTitle}
                  </MDTypography>
                  <MDTypography variant="h6" fontWeight="light" textTransform="capitalize">
                    <small>Pass Mark: {parseFloat(quizPassMark, 10).toFixed(2)}%</small>
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <Tooltip title="Edit Assessment">
                    <MDButton
                      variant="outlined"
                      color="warning"
                      iconOnly
                      size="small"
                      onClick={() => {
                        setOpenEditQuizDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                    </MDButton>
                  </Tooltip>
                  &nbsp;&nbsp;
                  <Tooltip title="Add Question">
                    <MDButton
                      variant="outlined"
                      color="info"
                      iconOnly
                      size="small"
                      onClick={() => {
                        setQuizQuestion(null);
                        setOpenAddQuestionDialog(true);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                    </MDButton>
                  </Tooltip>
                  &nbsp;&nbsp;&nbsp;
                  {/* <Tooltip title="Back To Course">
                    <MDButton
                      variant="outlined"
                      color="dark"
                      iconOnly
                      size="small"
                      onClick={() => {
                        window.history.go(-1);
                      }}
                    >
                      <Icon sx={{ fontWeight: "bold" }}>keyboard_arrow_left</Icon>
                    </MDButton>
                  </Tooltip> */}
                </MDBox>
              </MDBox>
              <MDBox mt={5}>
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  fontSize={12}
                  textTransform="capitalize"
                >
                  Description
                </MDTypography>
                <MDTypography mt={1} fontSize="medium" fontWeight="light">
                  {quizDescription}
                </MDTypography>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        <MDBox mt={5}>
          {questions.map((question, index) => (
            <MDBox key={`${question.reference}`} mb={3}>
              <Card>
                <MDBox p={3}>
                  <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDBox>
                      <MDTypography variant="h6" fontWeight="regular">
                        {index + 1} . {question.question}
                      </MDTypography>
                    </MDBox>
                    <MDBox>
                      <Tooltip title="Add Answer">
                        <MDButton
                          variant="outlined"
                          color="dark"
                          iconOnly
                          size="small"
                          onClick={() => {
                            setSelectedQuestion(question);
                            setAnswerText(null);
                            setIsAnswerCorrect(false);
                            setOpenAddAnswerDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        </MDButton>
                      </Tooltip>
                      &nbsp;&nbsp;
                      <Tooltip title="Edit Question">
                        <MDButton
                          variant="outlined"
                          color="info"
                          iconOnly
                          size="small"
                          onClick={() => {
                            setQuizQuestion(question.question);
                            setSelectedQuestion(question);
                            setOpenEditQuestionDialog(true);
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>edit</Icon>
                        </MDButton>
                      </Tooltip>
                      &nbsp;&nbsp;
                      <Tooltip title="Delete Question">
                        <MDButton
                          variant="outlined"
                          color="error"
                          iconOnly
                          size="small"
                          onClick={() => {
                            if (window.confirm(`Delete?`) === true) {
                              deleteQuestion(question.reference);
                            }
                          }}
                        >
                          <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                        </MDButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <MDBox mt={3}>
                    {question.answers.map((answer, idx) => (
                      <MDBox
                        pl={3}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                      >
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="light">
                            {idx + 1} . {answer.answer}
                            <br />
                            <small>{answer.correct ? <b>Correct</b> : "Wrong"}</small>
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <Tooltip title="Delete Answer">
                            <MDButton
                              variant="outlined"
                              color="error"
                              iconOnly
                              circular
                              size="small"
                              onClick={() => {
                                if (window.confirm(`Delete?`) === true) {
                                  deleteAnswer(answer.reference);
                                }
                              }}
                            >
                              <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
                            </MDButton>
                          </Tooltip>
                        </MDBox>
                      </MDBox>
                    ))}
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          ))}
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CourseTest;
